import { IChingGateLine, IChingLinePosition } from '../core/iching.models';

/** Poort (= hexagram) met optionele lijn: bij gate-granulariteit van de transits is de lijn onbekend. */
export interface HdIChingGatePoint {
  readonly gate: number;
  readonly line?: IChingLinePosition;
}

/** Eén persoon in de paarweergave: naam en bewuste zon (poort = hexagram, lijn). */
export interface HdIChingPairPerson {
  readonly name: string;
  readonly gate: number;
  readonly line: IChingLinePosition;
}

/**
 * Navigatiedoelen binnen het Classic I Ching-paneel. De dag-, geboorte- en
 * paarweergave krijgen al hun gegevens mee (geen chart-id, geen herberekening
 * in het paneel): `dateKey` = lokale dag `YYYY-MM-DD`, `birthLocal` = lokale
 * kloktijd van de chart `YYYY-MM-DDTHH:mm`.
 */
export type HdIChingPanelTarget =
  | { readonly view: 'overview' }
  | { readonly view: 'hexagram'; readonly number: number; readonly focusLine?: IChingLinePosition }
  | {
      readonly view: 'day';
      readonly dateKey: string;
      readonly sun: HdIChingGatePoint;
      readonly moon?: HdIChingGatePoint;
      /** Geformatteerd moment (Just Now, ephemeris-rij) in plaats van alleen de dag. */
      readonly momentLabel?: string;
    }
  | {
      readonly view: 'birth';
      readonly name?: string;
      readonly personalitySun: IChingGateLine;
      readonly designSun: IChingGateLine;
      readonly birthLocal?: string;
    }
  | { readonly view: 'pair'; readonly a: HdIChingPairPerson; readonly b: HdIChingPairPerson };

export type HdIChingDayTarget = Extract<HdIChingPanelTarget, { view: 'day' }>;
export type HdIChingBirthTarget = Extract<HdIChingPanelTarget, { view: 'birth' }>;
export type HdIChingPairTarget = Extract<HdIChingPanelTarget, { view: 'pair' }>;

export interface HdIChingPanelData {
  readonly target: HdIChingPanelTarget;
}

export const HD_ICHING_PANEL_KEY = 'classic-iching';
